import { render, staticRenderFns } from "./DevicePhoneDetails.vue?vue&type=template&id=9b473598&scoped=true"
import script from "./DevicePhoneDetails.vue?vue&type=script&lang=js"
export * from "./DevicePhoneDetails.vue?vue&type=script&lang=js"
import style0 from "./DevicePhoneDetails.vue?vue&type=style&index=0&id=9b473598&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b473598",
  null
  
)

export default component.exports